import * as React from 'react';
import { Link as GatsbyLink } from 'gatsby';

const CMSUrl =
  process.env.GATSBY_CMS_URL || 'https://cms.cppcrax.arcadiandigital.com.au';

export default function Link({ children, to, className, forceUseAnchorTag = false, ...other }) {
  let linkTo = to;
  if (!linkTo) {
    linkTo = '';
  }
  /* eslint-disable-next-line no-constant-condition */
  if (!typeof linkTo === 'object') {
    if (linkTo.startsWith(CMSUrl)) {
      linkTo = linkTo.replace(CMSUrl, '');
    }
  }
  const internal = /^\/(?!\/)/.test(linkTo);

  if (!forceUseAnchorTag && internal) {
    return (
      <GatsbyLink
        to={linkTo}
        className={`internal-link ${className ? className : ''}`}
        {...other}
      >
        {children}
      </GatsbyLink>
    );
  }

  if (typeof linkTo === 'object') {
    return (
      <a
        href={linkTo.uri}
        className={`external-link ${className ? className : ''}`}
        {...other}
      >
        {children}
      </a>
    );
  } else {
    return (
      <a
        href={linkTo}
        className={`external-link ${className ? className : ''}`}
        {...other}
      >
        {children}
      </a>
    );
  }
}
